import config from '../config';
import store from '@/store';

class WebSocketService {
    constructor() {
        this.websocket = null;
        this.websocketOpened = false;
        this.reconnectInterval = 5000;
    }

    static connect(loggedUser) {
        this.websocket = new WebSocket(
            `${config.websocketUrl}/${loggedUser.id}`
        );

        this.websocket.onopen = () => {
            this.websocketOpened = true;

            console.log('WebSocket connection established');
        };

        this.websocket.onerror = () => {
            this.websocketOpened = false;

            console.log('WebSocket error');
        };

        this.websocket.onclose = () => {
            this.websocketOpened = false;

            console.log('WebSocket connection closed');
        };

        this.websocket.onmessage = message => {
            const { type, data } = JSON.parse(message.data);

            if (type === 'CONTRACT_CREATED') {
                store.commit('contracts/addContract', data);
            }

            if (type === 'CONTRACT_DELETED') {
                store.commit('contracts/deleteContract', data);
            }

            if (type === 'CONTRACT_UPDATED') {
                store.commit('contracts/setContract', data);
            }

            if (type === 'CONTRACT_RESTORED') {
                store.commit('contracts/deleteDeletedContract', data);
                store.commit('contracts/addContract', data);
            }

            if (type === 'VACATION_CREATED') {
                store.commit('vacations/addVacation', data);
            }

            if (type === 'VACATION_CONFIRMED') {
                store.commit('vacations/deleteNotConfirmedVacation', data);
                store.commit('vacations/setVacation', data);
            }

            if (type === 'VACATION_UPDATED') {
                store.commit('vacations/setVacation', data);
            }

            if (type === 'VACATION_DELETED') {
                store.commit('vacations/deleteVacation', data);
            }
        };
    }

    static disconnect() {
        if (this.websocket) {
            this.websocket.close();
        }
    }
}

export default WebSocketService;
